import { defineMessages } from 'react-intl';

export const heidi2UpgradeCheckoutMessages = defineMessages({
  title: {
    id: '72YLanSNST',
    defaultMessage: 'Upgrade your team plan',
    description:
      'Page title of the checkout where a Practice admin moves members to Max seats',
  },
  back: {
    id: 'qAnWTD+ulj',
    defaultMessage: 'Back',
    description: 'Accessible label for the back button on the team plan upgrade checkout',
  },
  planDetails: {
    id: 'aRYuq2lGwu',
    defaultMessage: 'Plan details',
    description:
      'Section heading above the billing period and seat options in the upgrade checkout',
  },
  billingPeriod: {
    id: 'qAFdcVQ/Hi',
    defaultMessage: 'Billing period',
    description:
      'Accessible label for the billing period options in the upgrade checkout',
  },
  yearlyBilling: {
    id: 'pA/M718ApC',
    defaultMessage: 'Yearly billing',
    description: 'Billing period option in the upgrade checkout',
  },
  monthlyBilling: {
    id: 'jmh3UzSb+I',
    defaultMessage: 'Monthly billing',
    description: 'Billing period option in the upgrade checkout',
  },
  current: {
    id: '9ubg8MOPZC',
    defaultMessage: 'Current',
    description: 'Badge marking the billing period or seat the team is on today',
  },
  seatType: {
    id: 'panHpQcwH+',
    defaultMessage: 'Seat type',
    description:
      'Accessible label for the Standard and Max seat options in the upgrade checkout',
  },
  standardSeat: {
    id: 'T9KMbonNlQ',
    defaultMessage: '<strong>Standard seat:</strong> {price} user/month*',
    description:
      'Standard seat option in the upgrade checkout. {price} is a formatted monthly price; the asterisk points at the sales tax footnote.',
  },
  standardSeatWithOriginalPrice: {
    id: 's7SXiSgNEY',
    defaultMessage:
      '<strong>Standard seat:</strong> <original>{originalPrice}</original> {price} user/month*',
    description:
      'Standard seat option in the upgrade checkout when yearly billing lowers the price. {originalPrice} is the monthly-billing price shown struck through, {price} the yearly price per month; the asterisk points at the sales tax footnote.',
  },
  standardSeatDescription: {
    id: 'UkcoKV5fWG',
    defaultMessage: 'Everything you need in the consult',
    description: 'Supporting copy under the Standard seat option in the upgrade checkout',
  },
  maxSeat: {
    id: '7QfA6O+qcV',
    defaultMessage: '<strong>Max seat:</strong> {price} user/month*',
    description:
      'Max seat option in the upgrade checkout. {price} is a formatted monthly price; the asterisk points at the sales tax footnote.',
  },
  maxSeatDescription: {
    id: 'pXrW7ZZB1q',
    defaultMessage: 'For clinicians using Agents daily',
    description: 'Supporting copy under the Max seat option in the upgrade checkout',
  },
  pricesFootnote: {
    id: 'raib+uSfz4',
    defaultMessage: '*Prices exclude applicable sales tax. Terms and conditions apply.',
    description: 'Footnote under the seat options in the upgrade checkout',
  },
  searchPlaceholder: {
    id: 'gKILPFljA5',
    defaultMessage: 'Search for a member',
    description: 'Placeholder in the team member search field of the upgrade checkout',
  },
  clearSearch: {
    id: '4Ja8evmfwk',
    defaultMessage: 'Clear search',
    description: 'Accessible label for the button that clears the team member search',
  },
  nameColumn: {
    id: 'GCFbRyTLB1',
    defaultMessage: 'Name',
    description: 'Column header for team member names in the upgrade checkout',
  },
  roleColumn: {
    id: 'JjRlxyizMJ',
    defaultMessage: 'Role',
    description: 'Column header for team member roles in the upgrade checkout',
  },
  seatColumn: {
    id: 'BvYYVwGblo',
    defaultMessage: 'Seat',
    description:
      'Column header for the seat each team member holds (Standard, Max or Lite) in the upgrade checkout',
  },
  selectAllMembers: {
    id: 'bvcX4PtW+k',
    defaultMessage: 'Select all members',
    description:
      'Accessible label for the checkbox that selects every eligible team member',
  },
  selectMember: {
    id: 'HzMuLlpUeo',
    defaultMessage: 'Select {name}',
    description:
      'Accessible label for the checkbox that selects one team member for a Max seat',
  },
  moreRoles: {
    id: 'ni3OvX7VlR',
    defaultMessage: '+{count}',
    description:
      'Badge beside a team member’s first role, counting the other roles they hold',
  },
  moreRolesLabel: {
    id: '5RIMRf0J+p',
    defaultMessage: '{count, plural, one {# more role} other {# more roles}}: {roles}',
    description:
      'Screen reader label for the badge counting a team member’s other roles; roles is a list of role names',
  },
  maxSeatShort: {
    id: '+jnmv+yYbg',
    defaultMessage: 'Max',
    description:
      'Seat column value for a team member already on, or scheduled for, a Max seat',
  },
  standardSeatShort: {
    id: 'mBMXOPAa/9',
    defaultMessage: 'Standard',
    description: 'Seat column value for a team member on a Standard seat',
  },
  liteSeatShort: {
    id: 'MiCcYxnRkS',
    defaultMessage: 'Lite',
    description:
      'Seat column value for a team member without a paid seat, such as an assistant, who cannot move to Max',
  },
  assignSeat: {
    id: 'OsXflyghUb',
    defaultMessage: 'Assign seat',
    description:
      'Heading above the member list where the admin picks who gets a Max seat',
  },
  noMembersFound: {
    id: '/7CSMJRmjg',
    defaultMessage: 'No members match your search',
    description:
      'Empty state when the team member search in the upgrade checkout has no results',
  },
  membersError: {
    id: 'AS6J4yJPfT',
    defaultMessage: 'Couldn’t load your team members.',
    description:
      'Error shown when the team member list in the upgrade checkout fails to load',
  },
  loadingMembers: {
    id: 'UJKGXtAny2',
    defaultMessage: 'Loading team members',
    description: 'Accessible label for the placeholder shown while team members load',
  },
  forCareTeams: {
    id: 'IB/ApbqJdZ',
    defaultMessage: 'For care teams',
    description: 'Badge on the Practice Max plan card in the upgrade checkout',
  },
  practiceMax: {
    id: 'KpmwxhgbW3',
    defaultMessage: 'Practice Max',
    description: 'Plan name on the plan card in the upgrade checkout',
  },
  practiceStandard: {
    id: '1aQomi2Ng5',
    defaultMessage: 'Practice Standard',
    description:
      'Plan name on the plan card in the upgrade checkout when a Scribe Team picks Standard seats',
  },
  perUserYear: {
    id: '8EsBvln/Nb',
    defaultMessage: 'user / year',
    description:
      'Unit shown after the yearly per-user price on the Practice Max plan card',
  },
  everythingInPracticePlus: {
    id: 'X8WEV7aqZ9',
    defaultMessage: 'Everything in Practice Standard, plus:',
    description: 'Lead-in above the Practice Max feature list in the upgrade checkout',
  },
  featureMaxUsage: {
    id: 'VSsVCM2ifz',
    defaultMessage: 'Maximum usage allowance for agentic work',
    description: 'Practice Max feature in the upgrade checkout plan card',
  },
  featureRegularAgenticUse: {
    id: 'tvooDL7/ui',
    defaultMessage: 'Designed for regular agentic use',
    description: 'Practice Max feature in the upgrade checkout plan card',
  },
  featureEarlyAccess: {
    id: 'paajc0+xgG',
    defaultMessage: 'Early access to advanced agentic features',
    description: 'Practice Max feature in the upgrade checkout plan card',
  },
  lineScribeTeam: {
    id: 'KjrnGhwldi',
    defaultMessage: 'Scribe Team',
    description:
      'Invoice line in the upgrade checkout naming the Scribe Team plan a team is leaving',
  },
  lineClinicianMax: {
    id: 'YOa5KUgla7',
    defaultMessage: 'Clinician Max',
    description:
      'Invoice line in the upgrade checkout naming the Clinician Max plan a team is leaving',
  },
  lineClinicianStandard: {
    id: 'IgU6ob2F7Q',
    defaultMessage: 'Clinician Standard',
    description:
      'Invoice line in the clinician upgrade checkout for a Clinician Standard credit or charge',
  },
  nextStepNote: {
    id: 'VN6Ge301+v',
    defaultMessage: 'Discount and taxes applied in next step',
    description:
      'Note under a subtotal-only invoice preview; the payment step that follows shows the final amounts',
  },
  lineSeats: {
    id: 'efhm9ESfXh',
    defaultMessage: '{quantity} x {plan}',
    description:
      'Invoice line title in the upgrade checkout: seat count and plan, e.g. "10 x Practice Standard"',
  },
  lineProratedRemaining: {
    id: 'PgQCmVLSFn',
    defaultMessage: 'Prorated remaining',
    description:
      'Caption under an invoice line in the upgrade checkout: credit for the unused rest of the current plan',
  },
  lineProratedCharge: {
    id: 'k1jTSj/K/e',
    defaultMessage: 'Prorated charge',
    description:
      'Caption under an invoice line in the upgrade checkout: charge for the rest of the billing period',
  },
  subtotal: {
    id: 'jJOio9SbcN',
    defaultMessage: 'Subtotal',
    description: 'Subtotal row of the price breakdown in the upgrade checkout',
  },
  gst: {
    id: 'Bsc/v6JYjR',
    defaultMessage: 'GST',
    description: 'Australian GST row of the price breakdown in the upgrade checkout',
  },
  tax: {
    id: 'nf7OJnawPn',
    defaultMessage: 'Tax',
    description: 'Sales tax row of the price breakdown in the upgrade checkout',
  },
  taxInfo: {
    id: 'Dt87QBFYDk',
    defaultMessage: 'Tax is finalized when the invoice is issued.',
    description: 'Tooltip on the tax row of the price breakdown in the upgrade checkout',
  },
  total: {
    id: 'oYr7aEM2Ie',
    defaultMessage: 'Total',
    description: 'Total row of the price breakdown in the upgrade checkout',
  },
  loadingInvoice: {
    id: 'vkuHs5OGZg',
    defaultMessage: 'Loading price breakdown',
    description:
      'Accessible label for the placeholder shown while the upgrade price loads',
  },
  invoiceError: {
    id: 'BSnhpIx8yq',
    defaultMessage: 'Couldn’t calculate the price. Try again in a moment.',
    description: 'Error shown when the upgrade price preview fails',
  },
  scheduleNote: {
    id: 'NluGEvBSSg',
    defaultMessage: 'This prorated charge will be included in your next invoice.',
    description:
      'Note above the Upgrade button when a Practice team picks members for Max seats',
  },
  schedulingPaused: {
    id: 'IVyVq+E/gM',
    defaultMessage:
      'Scheduling upgrades is paused while we update billing. Please try again later.',
    description:
      'Note above the disabled Upgrade button while scheduling team upgrades is temporarily paused',
  },
  upgrade: {
    id: 'hvzh1O0/1R',
    defaultMessage: 'Upgrade',
    description:
      'Checkout button that upgrades the team: schedules members onto Max seats, or moves a Scribe Team onto Practice',
  },
});
